import React from "react"

const IconPlay = props => (
  <svg width="37" height="42" viewBox="0 0 37 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.36377 2.66417V39.3381C0.36377 40.641 1.41933 41.7071 2.70946 41.7071C3.11995 41.7071 3.51579 41.6034 3.8823 41.3961L35.5491 23.0518C36.6779 22.4003 37.0591 20.9493 36.4141 19.8241C36.2088 19.4539 35.9009 19.1578 35.5491 18.9506L3.8823 0.606168C2.75344 -0.0452868 1.31671 0.35447 0.671641 1.47971C0.466393 1.84986 0.36377 2.24961 0.36377 2.66417Z" fill="currentColor" />
  </svg>
)

export default IconPlay
